import scrollTo from "../../functions/scrollTo";
import {
    changeConceptCode, changeConceptCommentsExpanded, changeConceptName,
    changeConceptPath, changeConceptPathIndexes, changeConceptPathString,
    changeConceptSelected, changeNewChildConcepts, changeTermChanged,
    changeTermComments, changeTermMyVotes, changeTermVotes
} from "../../slices/codeSystemTermDetail/codeSystemTermDetailSlice";

const navigateToAnotherTerm = (dispatch, resourceId,
    concept, display, path, pathIndexes, pathString, navigate
) => {
    let conceptCode = "";
    let scrollToId = "";
    if (concept.code && typeof concept.code === "string") {
        conceptCode = concept.code;
        scrollToId = "termdetail-navigation-code-" + conceptCode;
    }

    if (conceptCode) {
        //navigate(`/resources/CodeSystem/${resourceId}#${conceptCode}`); //We need the replace unless we have back/forward go to the previous terms //, { replace: true }
    } else {
        //navigate(`/resources/CodeSystem/${resourceId}`, { replace: true }); //We need the replace unless we have back/forward go to the previous terms
        pathIndexes = undefined;
        concept = undefined;
        navigate(`/resources/CodeSystem/${resourceId}#TOP`); //, { replace: true }
    }

    dispatch(changeConceptName(display));
    dispatch(changeConceptPath(path));
    dispatch(changeConceptPathIndexes(pathIndexes));
    dispatch(changeConceptPathString(pathString));
    dispatch(changeConceptSelected(concept));
    dispatch(changeConceptCode(concept?.code));
    dispatch(changeTermChanged(false));
    dispatch(changeNewChildConcepts([]));
    dispatch(changeConceptCommentsExpanded(false));
    dispatch(changeTermComments([]));
    dispatch(changeTermMyVotes([]));
    dispatch(changeTermVotes([]));
    scrollTo("navigationtermDetailSegment", scrollToId, true);
    scrollTo("resourceTextViewSegment", "", true);


};

export default navigateToAnotherTerm;